import { mapState } from 'vuex'
import listItemPlayer from '@/components/list-item-player/list-item-player.vue'

export default {
  components: {
    listItemPlayer
  },
  data () {
    return {
      group: '',
      search: null
    }
  },
  computed: {
    ...mapState(['players', 'teams']),
    groups () {
      let players = Object.values(this.players)
      if (this.search) {
        players = players.filter(p => `${p.firstName} ${p.lastName} ${p.nickName}`.toLowerCase().includes(this.search.toLowerCase()))
      }

      if (this.group === 'organizer') {
        return [{
          name: 'organizer',
          title: 'Organizator',
          players: players.filter(p => (p.badges || []).includes('organizer'))
        }]
      }
      if (this.group === 'team') {
        return Object.values(this.teams).map(team => ({
          name: team.id,
          title: team.name,
          players: players.filter(p => p.assignedTeam === team.id)
        }))
      }
      if (this.group === 'badges') {
        return players.reduce((res, player) => {
          const count = (player.badges || []).filter(b => b !== 'organizer').length
          const index = res.findIndex(r => r.name === `count-${count}`)
          if (index < 0) {
            res.push({
              name: `count-${count}`,
              title: `Odznaki: ${count}`,
              players: [player]
            })
          } else {
            res[index].players.push(player)
          }
          return res
        }, []).sort((a, b) => b.name.localeCompare(a.name))
      }
      if (this.group === 'fill') {
        return [{
          name: 'filled',
          title: 'Uzupełnione',
          players: players.filter(p => p.photoUrl)
        }, {
          name: 'nonfilled',
          title: 'Nieuzupełnione',
          players: players.filter(p => !p.photoUrl)
        }]
      }
      return [{
        name: 'all',
        title: 'Wszyscy zawodnicy',
        players
      }]
    }
  }
}
